<template>
    <div  class="load_cover">
        <div class="row" style="position: absolute;left:50%;top:40%;">
          <div class="col py-4" style="position: relative; left: -50%;top:-40%;">
            <div class="sk-chase sk-primary" style="margin-left:12px;">
              <div class="sk-chase-dot"></div>
              <div class="sk-chase-dot"></div>
              <div class="sk-chase-dot"></div>
              <div class="sk-chase-dot"></div>
              <div class="sk-chase-dot"></div>
              <div class="sk-chase-dot"></div>
            </div>
            <div class="loading">loading...</div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Loading',
  data () {
    return {
    }
  }
}
</script>

<style scoped>
  .loading{
      margin-top:20px;
      font-size: 16px;
      text-align: center;
      color:#ddd;
  }
  .load_cover{
    width: 100%;
    height: 100%;
    background: rgba(255,255,255,.4);
    z-index: 9999;
    position: fixed;
    left: 0;
    top:0;
    font-size: 20px;;
  }
  *{
    padding: 0;
    margin: 0;
  }
  html,body{
    width: 100%;
  }
</style>
